import { createApp } from "vue";
import pinia from "/@/stores/index";
import App from "/@/App.vue";
import router from "/@/router";
import { useDirective } from "./directive";

import ElementPlus from "element-plus";
import locale from "element-plus/es/locale/lang/zh-cn";

import "/@/theme/index.scss";
import 'viewerjs/dist/viewer.css'

import Viewer from 'v-viewer'

const app = createApp(App);
useDirective(app);

app.use(pinia).use(router).use(ElementPlus, { locale }).use(Viewer).mount("#app");
